import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import {Button, Item} from "semantic-ui-react";
import {Icon} from "../../../core/components/icon/icon";
import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";


export interface ContentInfoBoxProps {
    view?: __esri.MapView | __esri.SceneView | undefined;
    mapViewerConfig: MapViewerConfiguration;
    type: string;
    url: string | null;
}

@observer
export class ContentInfoBox extends Component<ContentInfoBoxProps, any> {

    constructor(props: ContentInfoBoxProps) {
        super(props);
        this.state = {
            search: null
        };
    }

    render(): React.ReactElement | null {
        const {type, url} = this.props;
        const infoContent = this.props.mapViewerConfig.htmlContent[type + "Info"];
        if (!infoContent || typeof infoContent === "string"){
            return null;
        }
        // quick and dirty!
        const mainContent = <div dangerouslySetInnerHTML={
            {__html: infoContent.content}}/>;
        return(
            <Item key={type}>
                <Item.Image src={"./images/external_" + type + ".png"}/>

                <Item.Content>
                    <Item.Header as="a" target={"_blank"}
                        href={url}>{infoContent.title}
                    </Item.Header>
                    <Item.Description>{mainContent}</Item.Description>
                    <Item.Extra>
                        <Button as={"a"} primary floated="right" target={"_blank"} href={url}>
                            <Icon name={"navigate_right"} />
                            {infoContent.link}
                        </Button>
                    </Item.Extra>
                </Item.Content>
            </Item>
        );
    }
}
